import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as CalendarIcon } from './calendar.svg';

export const Calendar = IconHOC(CalendarIcon);
